export default __webpack_public_path__ + "static/media/joltify.b016fb56.svg";